import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

import { useColorMode } from "@/shared/store/theme-store";
import { Toaster } from "@/shared/ui/sonner";

export function ToastProvider() {
  const [mounted, setMounted] = useState(false);
  const colorMode = useColorMode();

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return createPortal(
    <Toaster
      richColors
      closeButton
      position="top-right"
      theme={colorMode}
    />,
    document.body,
  );
}
